import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import {
  payCalendarsService,
  PayCalendar,
  CreatePayCalendarRequest,
} from '@aslanpay/portal-common-lib';

const useCreatePayCalendar = ({
  onSuccess,
  onError,
}: UseMutationOptions<PayCalendar, Error, CreatePayCalendarRequest>) => {
  return useMutation<PayCalendar, Error, CreatePayCalendarRequest>(
    ({
      name,
      externalPayCalendarId,
      companyId,
      location,
      currency,
      payFrequency,
      odpAllowancePercentage,
      globalAllowancePercentage,
      startingBalanceDays,
      defaultAnnualGrossSalary,
      startDate,
      payrollCutoff,
      payrollCutoffDays,
      payrollCutoffCustomDay,
      payday,
      paydayLastCustomWeekday,
      paydayFirstCustomWeekday, // NEW: First custom weekday for payday
      paydayCustomDay,
      workingDays,
      payType,
      inArrearsDays,
      payrollCutoffFixedDay,
      paydayFixedDay,
      paydayNonBusinessDayFailover,
      cutoffNonBusinessDayFailover,
      fullPeriodStartingBalance,
      accrualPeriod, // NEW: Accrual period configuration
      salariedDeductionsRequestMadeAvailableConfig, // NEW: Salaried deductions config
      nonSalariedDeductionsRequestMadeAvailableConfig, // NEW: Non-salaried deductions config
    }: CreatePayCalendarRequest) =>
      payCalendarsService.createPayCalendar({
        name,
        externalPayCalendarId,
        companyId,
        location,
        currency,
        payFrequency,
        odpAllowancePercentage,
        globalAllowancePercentage,
        startingBalanceDays,
        defaultAnnualGrossSalary,
        startDate,
        payrollCutoff,
        payrollCutoffDays,
        payrollCutoffCustomDay,
        payday,
        paydayLastCustomWeekday,
        paydayFirstCustomWeekday, // NEW: First custom weekday for payday
        paydayCustomDay,
        workingDays,
        payType,
        inArrearsDays,
        payrollCutoffFixedDay,
        paydayFixedDay,
        paydayNonBusinessDayFailover,
        cutoffNonBusinessDayFailover,
        fullPeriodStartingBalance,
        accrualPeriod, // NEW: Accrual period configuration
        salariedDeductionsRequestMadeAvailableConfig, // NEW: Salaried deductions config
        nonSalariedDeductionsRequestMadeAvailableConfig, // NEW: Non-salaried deductions config
      }),
    { onSuccess, onError }
  );
};

export default useCreatePayCalendar;
